import React from 'react'
import Styled from 'styled-components'
import { lighten, darken } from 'polished'

import { Link } from 'router/index'

const HybridLink = ({ to, href, children, ...props }) => {
  if (to) {
    return <Link to={to} {...props}>{children}</Link>
  }

  if (href) {
    return <a href={href} {...props}>{children}</a>
  }

  throw Error('Link must have "to" or "href" prop')
}

export default Styled(HybridLink)`
  color: ${props => props.theme.colors.primary.shade400};
  text-decoration: none;
  transition: 300ms;

  &:hover {
    color: ${props => lighten(0.05, props.theme.colors.primary.shade400)};
  }

  &:active {
    color: ${props => darken(0.05, props.theme.colors.primary.shade400)};
  }
`


// WEBPACK FOOTER //
// ./src/components/Link/index.js